import { useEffect, useRef } from "react";
import { ChatsCircle } from "@phosphor-icons/react";
import { MilestoneChip } from "./MilestoneChip";
import { dayKey, dayLabel } from "./threadUtils";

/* Scrollable chat list: day dividers, notes rendered via `renderNote`, milestones as chips. Sticks to the newest entry. */
export function ThreadList({ items = [], renderNote, showMilestones = true, emptyText = "No messages yet.", testPrefix = "note", maxHeight = "max-h-[520px]" }) {
  const ref = useRef(null);
  const visible = showMilestones ? items : items.filter((i) => i.kind !== "milestone");

  useEffect(() => {
    const el = ref.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [visible.length]);

  if (visible.length === 0) {
    return (
      <div className="py-10 text-center" data-testid={`${testPrefix}-empty`}>
        <ChatsCircle size={30} weight="duotone" className="mx-auto text-muted-foreground/40 mb-2" />
        <p className="text-xs text-muted-foreground">{emptyText}</p>
      </div>
    );
  }

  let lastDay = "";
  return (
    <div ref={ref} className={`space-y-2.5 overflow-y-auto pr-1 ${maxHeight}`} data-testid={`${testPrefix}-thread`}>
      {visible.map((item) => {
        const k = dayKey(item.created_at);
        const divider = k !== lastDay;
        lastDay = k;
        return (
          <div key={`${item.kind}-${item.id}`} className="space-y-2.5">
            {divider && (
              <div className="flex justify-center pt-1">
                <span className="rounded-full bg-muted px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">{dayLabel(item.created_at)}</span>
              </div>
            )}
            {item.kind === "milestone" ? <MilestoneChip item={item} testPrefix={testPrefix} /> : renderNote(item)}
          </div>
        );
      })}
    </div>
  );
}
